
import { defineComponent, onMounted, reactive, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "urusan-laporan",
  props: {},
  setup() {
    const router = useRouter();
    const isReportDialogOpen = ref(false);
    const variables = reactive({
      input: "",
    });
    let data = reactive({
      id: "",
      title: "",
    });
    const laporan = ref([
      {
        id: 1,
        color: "warning",
        icon: "icons/duotune/abstract/abs027.svg",
        title: "Senarai Pengguna Aktif/Tidak Aktif",
        text: "31 Mar 2022",
        number: "+28%",
        reportType: "Laporan_Pengguna",
        reportName: "LPE_PE01_Pengguna_Aktif_Tidak_Aktif",
      },
      {
        id: 2,
        color: "success",
        icon: "icons/duotune/art/art005.svg",
        title: "Laporan Pengguna Berdaftar",
        text: "05 Mar 2022",
        number: "+50%",
        reportType: "Laporan_Pengguna",
        reportName: "LPE_PE02_Pengguna_Berdaftar",
      },
      {
        id: 3,
        color: "danger",
        icon: "icons/duotune/communication/com012.svg",
        title: "Laporan Transaksi Penggunaan Modul",
        text: "14 Feb 2022",
        number: "-27%",
        reportType: "Laporan_Pengguna",
        reportName: "LPE_PE03_Transaksi_Modul",
      },
      {
        id: 4,
        color: "info",
        icon: "icons/duotune/communication/com012.svg",
        title: "Laporan Jejak Audit",
        text: "01 Feb 2022",
        number: "+8%",
        reportType: "Laporan_Pengguna",
        reportName: "LPE_PE04_Audit_Trail",
      },
    ]);
    // const { mutate } = useMutation(pentadbirPrint, () => ({
    //   variables: {
    //     input: {
    //       id: data.id,
    //       title: data.title,
    //     },
    //   },
    // }));
    onMounted(() => {
      setCurrentPageBreadcrumbs("Laporan Pentadbiran Sistem", [
        "Laporan",
        "Pentadbiran Sistem",
      ]);
    });

    return {
      laporan,
      isReportDialogOpen,
      displayReport,
      data,
    };

    function displayReport(
      id: number,
      title: string,
      reportType: string,
      reportName: string
    ) {
      router.push({
        name: "laporan-display",
        params: {
          id,
          title,
          breadCrumb: "Pentadbiran Sistem",
          reportType,
          reportName,
        },
      });
      // mutate();
    }
  },
});
